// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
#announcement-root {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  width: 100%;
}

.srprs-announcement {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  position: relative;
  opacity: 0;
  visibility: hidden;
  right: -50px;
  transition: all 0.25s ease-out;
  padding: 20px;
  line-height: 1.25em;
  background-color: #e7e7e7;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
}
.srprs-announcement p {
  line-height: 1.35em;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 1em;
}
.srprs-announcement.show {
  opacity: 1;
  visibility: visible;
  right: 0;
}
.srprs-announcement.type-error {
  color: #fff;
  background-color: #eb3a3c;
}
.srprs-announcement.type-info {
  color: #fff;
  background-color: #0000ee;
}
.srprs-announcement.type-price {
  background-color: #f5ea47;
}
.srprs-announcement.type-time {
  color: #fff;
  background-color: #f87498;
}
.srprs-announcement.type-persuasion {
  background-color: #bade94;
}
.srprs-announcement.turquoise {
  color: #222;
  background-color: #1ececa;
}
.srprs-announcement.mint {
  color: #222;
  background-color: #a0ddd2;
}
.srprs-announcement.green {
  color: #222;
  background-color: #bade94;
}
.srprs-announcement.purple {
  color: #222;
  background-color: #b599c6;
}
.srprs-announcement.pink {
  color: #222;
  background-color: #f87498;
}
.srprs-announcement.blue {
  color: #222;
  background-color: #00a0e0;
}
.srprs-announcement.steel-blue {
  color: #222;
  background-color: #a5bad6;
}
.srprs-announcement.yellow {
  color: #222;
  background-color: #f5ea47;
}
.srprs-announcement.orange {
  color: #222;
  background-color: #fac56d;
}
.srprs-announcement.pink-light {
  color: #222;
  background-color: #f0c5ce;
}
.srprs-announcement.red {
  color: #222;
  background-color: #f12535;
}
.srprs-announcement.grey {
  color: #222;
  background-color: #d3d3d3;
}
.srprs-announcement.black {
  color: #222;
  background-color: #222;
}
.srprs-announcement.white {
  color: #222;
  background-color: #fff;
}
.srprs-announcement.blue-light {
  color: #222;
  background-color: #aed7e8;
}
.srprs-announcement.purple-light {
  color: #222;
  background-color: #cfb9d2;
}
.srprs-announcement.red-light {
  color: #fff;
  background-color: #E7024C;
}
.srprs-announcement.tomato {
  color: #fff;
  background-color: #E56159;
}
.srprs-announcement.coral {
  color: #222;
  background-color: #F5661C;
}
.srprs-announcement.tomato-section {
  color: #222;
  background-color: #FF938C;
}
.srprs-announcement.mint-v2 {
  color: #222;
  background-color: #72BEA5;
}
.srprs-announcement.turquoise-light {
  color: #222;
  background-color: #C2E5ED;
}
.srprs-announcement.almond {
  color: #222;
  background-color: #F3D5CE;
}
.srprs-announcement.cinderella {
  color: #222;
  background-color: #FDE2DA;
}
.srprs-announcement.humming-bird {
  color: #222;
  background-color: #CDF2E6;
}
.srprs-announcement.golden-tainoi {
  color: #222;
  background-color: #FFCB55;
}
.srprs-announcement.pale-turquoise {
  color: #222;
  background-color: #C5EFF4;
}
.srprs-announcement.celadon {
  color: #222;
  background-color: #A7E8BB;
}
.srprs-announcement.morning-glory {
  color: #222;
  background-color: #91D1DA;
}
.srprs-announcement.shalimar {
  color: #222;
  background-color: #F7F5B0;
}
.srprs-announcement .announcement-icon > .srprs-icon {
  position: absolute;
  width: 22px;
  height: 22px;
  left: 0;
  top: 0;
  fill: currentColor;
  margin-top: 26px;
  margin-left: 20px;
}
.srprs-announcement .announcement-icon > .srprs-icon svg {
  width: 100%;
  height: auto;
}
.srprs-announcement .announcement-message {
  display: inline-block;
  padding-left: 36px;
  padding-right: 20px;
}
.srprs-announcement .announcement-close {
  position: absolute;
  width: 48px;
  height: 48px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  text-align: center;
  top: 5px;
  right: 5px;
}
.srprs-announcement .announcement-close:hover {
  transform: scale(1.15);
}
.srprs-announcement .announcement-close svg {
  width: 100%;
  height: auto;
  display: inline-block;
  fill: currentColor;
}

@media screen and (min-width: 768px) {
  #announcement-root {
    top: 20px;
    right: 20px;
    width: 450px;
  }
  .srprs-announcement {
    padding: 30px;
  }
  .srprs-announcement .announcement-icon .srprs-icon {
    width: 36px;
    height: 36px;
    margin-left: 30px;
    margin-top: 32px;
  }
  .srprs-announcement .announcement-message {
    padding-left: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Announcement/Announcement.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AAnMA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAqMF;;AAlMA;EIAI,6CAAA;EJEF,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EAEE,yBAAA;EAGF,WAAA;EAWE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAwLJ;AAnME;EACE,mBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,kBAAA;AAmMJ;AA3LE;EACE,UAAA;EACA,mBAAA;EACA,QAAA;AA6LJ;AAzLI;EACE,WAAA;EAEE,yBAAA;AA0LR;AAvLI;EACE,WAAA;EAEE,yBAAA;AAwLR;AArLI;EAEI,yBAAA;AAsLR;AAnLI;EACE,WAAA;EAEE,yBAAA;AAoLR;AAjLI;EAEI,yBAAA;AAkLR;AAzKI;EACE,WAAA;EACA,yBAAA;AA2KN;AA7KI;EACE,WAAA;EACA,yBAAA;AA+KN;AAjLI;EACE,WAAA;EACA,yBAAA;AAmLN;AArLI;EACE,WAAA;EACA,yBAAA;AAuLN;AAzLI;EACE,WAAA;EACA,yBAAA;AA2LN;AA7LI;EACE,WAAA;EACA,yBAAA;AA+LN;AAjMI;EACE,WAAA;EACA,yBAAA;AAmMN;AArMI;EACE,WAAA;EACA,yBAAA;AAuMN;AAzMI;EACE,WAAA;EACA,yBAAA;AA2MN;AA7MI;EACE,WAAA;EACA,yBAAA;AA+MN;AAjNI;EACE,WAAA;EACA,yBAAA;AAmNN;AArNI;EACE,WAAA;EACA,yBAAA;AAuNN;AAzNI;EACE,WAAA;EACA,sBAAA;AA2NN;AA7NI;EACE,WAAA;EACA,sBAAA;AA+NN;AAjOI;EACE,WAAA;EACA,yBAAA;AAmON;AArOI;EACE,WAAA;EACA,yBAAA;AAuON;AAzOI;EACE,WAAA;EACA,yBAAA;AA2ON;AA7OI;EACE,WAAA;EACA,yBAAA;AA+ON;AAjPI;EACE,WAAA;EACA,yBAAA;AAmPN;AArPI;EACE,WAAA;EACA,yBAAA;AAuPN;AAzPI;EACE,WAAA;EACA,yBAAA;AA2PN;AA7PI;EACE,WAAA;EACA,yBAAA;AA+PN;AAjQI;EACE,WAAA;EACA,yBAAA;AAmQN;AArQI;EACE,WAAA;EACA,yBAAA;AAuQN;AAzQI;EACE,WAAA;EACA,yBAAA;AA2QN;AA7QI;EACE,WAAA;EACA,yBAAA;AA+QN;AAjRI;EACE,WAAA;EACA,yBAAA;AAmRN;AArRI;EACE,WAAA;EACA,yBAAA;AAuRN;AAzRI;EACE,WAAA;EACA,yBAAA;AA2RN;AA7RI;EACE,WAAA;EACA,yBAAA;AA+RN;AAzRM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EAME,gBAAA;EACA,iBAAA;AAsRV;AA5RQ;EACE,WAAA;EACA,YAAA;AA8RV;AAtRI;EACE,qBAAA;EAEE,kBAAA;EACA,mBAAA;AAuRR;AApRI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAEE,6BAAA;EAEF,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAoRN;AAnRM;EACE,sBAAA;AAqRR;AAnRM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAqRR;;ACtZI;EDwIF;IACE,SAAA;IACA,WAAA;IACA,YAAA;EAkRF;EA/QA;IACE,aAAA;EAiRF;EA7QM;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,gBAAA;EA+QR;EA5QI;IACE,kBAAA;EA8QN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n@include color-schemes;\n\n#announcement-root {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: z-index(modal);\n  width: 100%;\n}\n\n.srprs-announcement {\n  @include box-shadow();\n  position: relative;\n  opacity: 0;\n  visibility: hidden;\n  right: -50px;\n  transition: all 0.25s ease-out;\n  padding: 20px;\n  line-height: 1.25em;\n  background: {\n    color: color(grey-light);\n  }\n\n  width: 100%;\n\n  p {\n    line-height: 1.35em;\n    font: {\n      size: 16px;\n      weight: 500;\n    }\n    margin-bottom: 1em;\n  }\n  margin: {\n    left: auto;\n    right: auto;\n    bottom: 30px;\n  }\n\n  &.show {\n    opacity: 1;\n    visibility: visible;\n    right: 0;\n  }\n\n  &.type {\n    &-error {\n      color: color(white);\n      background: {\n        color: color(error);\n      }\n    }\n    &-info {\n      color: color(white);\n      background: {\n        color: color(blue-darker);\n      }\n    }\n    &-price {\n      background: {\n        color: color(yellow);\n      }\n    }\n    &-time {\n      color: color(white);\n      background: {\n        color: color(pink);\n      }\n    }\n    &-persuasion {\n      background: {\n        color: color(green);\n      }\n    }\n  }\n\n  @each $color, $colorBackground, $colorBackgroundAccent, $colorBackgroundTone,\n    $colorForeground, $colorForegroundAccent,\n    $colorForegroundNegative in $list-colorschemes\n  {\n    &.#{\"\" + $color} {\n      color: color($colorForeground);\n      background-color: color($color);\n    }\n  }\n\n  .announcement {\n    &-icon {\n      > .srprs-icon {\n        position: absolute;\n        width: 22px;\n        height: 22px;\n        left: 0;\n        top: 0;\n        fill: currentColor;\n        svg {\n          width: 100%;\n          height: auto;\n        }\n        margin: {\n          top: 26px;\n          left: 20px;\n        }\n      }\n    }\n    &-message {\n      display: inline-block;\n      padding: {\n        left: 36px;\n        right: 20px;\n      }\n    }\n    &-close {\n      position: absolute;\n      width: 48px;\n      height: 48px;\n      border: none;\n      background: {\n        color: transparent;\n      }\n      cursor: pointer;\n      text-align: center;\n      top: 5px;\n      right: 5px;\n      &:hover {\n        transform: scale(1.15);\n      }\n      svg {\n        width: 100%;\n        height: auto;\n        display: inline-block;\n        fill: currentColor;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  #announcement-root {\n    top: 20px;\n    right: 20px;\n    width: 450px;\n  }\n\n  .srprs-announcement {\n    padding: 30px;\n\n    .announcement {\n      &-icon {\n        .srprs-icon {\n          width: 36px;\n          height: 36px;\n          margin-left: 30px;\n          margin-top: 32px;\n        }\n      }\n      &-message {\n        padding-left: 60px;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
